import { useEffect } from 'react';

import {
  usePrintsUiStore,
  usePrintsOrderStore,
  usePrintsConfigStore,
} from '../stores';
import {
  selectSizesByFinish,
  selectSizesWithPhotos,
  selectTotalQuantity,
} from '../stores/selectors';

import sendToGoogleAnalytics from '../../_libs/analytics/builder-send-to-google-analytics';
import { listDuplicatePhotos } from '../common/duplicate-detection/list-duplicate-photos';
import { VIEW_MODE } from '../constants';

export const useGa4EventSubscriber = () => {
  useEffect(() => {
    // Subscribe to UI Store for view mode changes in order to trigger `duplicate_photos_view_active` GA4 event
    const unsubscribeFromUIStore = usePrintsUiStore.subscribe(
      (state, prevState) => {
        if (
          state.currentView === VIEW_MODE.DUPLICATES &&
          prevState.currentView !== VIEW_MODE.DUPLICATES
        ) {
          const selectedFinishName = state.selectedFinishName;
          const { allSizes } = usePrintsConfigStore.getState();
          const photos = usePrintsOrderStore.getState().photos;
          const sizesWithPhotos = selectSizesWithPhotos(allSizes, photos);
          const sizesByFinish = selectSizesByFinish(
            sizesWithPhotos,
            selectedFinishName,
          );

          const { totalDuplicatesCount } = listDuplicatePhotos(sizesByFinish);
          const totalPhotosCount = selectTotalQuantity(photos);

          sendToGoogleAnalytics('duplicate_photos_view_active', '', {
            total_photos_count: totalPhotosCount, // eslint-disable-line camelcase
            total_duplicates_count: totalDuplicatesCount, // eslint-disable-line camelcase
          });
        }
      },
    );

    return () => {
      unsubscribeFromUIStore();
    };
  }, []);
};
